/***
 * ZDE BY MELI BYT DEKLAROVANY DEFINICE URL STRANEK
 * TYTO KONSTANTY BY MELI BYT PRAKTICKY POUZE PRO app.tsx A PRIME DEFINICE ROUTERU
 * PRO SAMOTNE PRESMEROVANI VIZ urlRedirectUtils.ts
 */

/***
 * NASLEDUJICI URL JSOU JEN PRO INTERNI REZIM
 */
export const MAPA_URL = '/';
export const DAVKY_DTM_URL = '/zmeny-dtm';
export const DTM_DETAIL_URL = '/zmeny-dtm/:id/:tab';
